<template>
  <x-page-container class="x-list-page common-page-container toolbar-page-container">
    <template v-slot:header>
      <x-button-group :button-config="buttonConfig">
        <template v-for="(item) in buttonSlotArray" v-slot:[item.name]="scope">
          <slot :name="item.name" v-bind="scope"></slot>
        </template>
      </x-button-group>
      <vxe-toolbar ref="vxeToolbar" class="page-header-toolbar" :custom="custom"></vxe-toolbar>
    </template>
    <template v-slot:sub>
      <div ref="sub">
        <slot name="subBeforeCondition"></slot>
        <x-condition ref="xCondition" :condition-config="conditionConfig" :drawer-config="realDrawerConfig" :drawer-flag="drawerFlag">
          <template v-for="(item) in conditionSlotArray" v-slot:[item.name]="scope">
            <slot :name="item.name" v-bind="scope"></slot>
          </template>
        </x-condition>
        <slot name="subAfterCondition"></slot>
        <x-download-dialog ref="downloadDialog" :downloadApi="downloadApi"
                           :listDownloadApi="listDownloadApi"
                           :deleteDownloadApi="deleteDownloadApi"
                           :download-params="downloadParams"
                           :excel-config="excelConfig"
        ></x-download-dialog>
        <el-tabs v-if="tabConfig" v-model="tabConfig.activeName" :type="tabConfig.type || 'card'"
                 @tab-click="handleTabClick">
          <el-tab-pane v-for="item in tabConfig.list" :key="item.name" :label="item.label"
                       :name="item.name"></el-tab-pane>
        </el-tabs>
        <slot name="subSuffix"></slot>
      </div>
    </template>
    <template v-slot:main>
      <x-table
          v-on="$listeners"
          v-bind="$attrs"
          :auto-resize="false"
          ref="xTable"
          border
          resizable
          height="100%"
          :row-config="rowConfig"
          :id="realId"
          :column-cache="realColumnCache"
          :scroll-y="scrollY"
          :seq-config="realSeqConfig"
          :sort-config="realSortConfig"
          :filter-config="realFilterConfig"
          :menu-config="realMenuConfig"
          :edit-config="realEditConfig"
          @cell-click="handleCellClick"
          @menu-click="handleMenuClick"
          :columns="columns"
          :handle-table-setting-update="handleTableSettingUpdate"
          :table-setting-config="realTableSettingConfig"
          :show-footer="showFooter"
          :footer-method="realFooterMethod"
          :align="'center' || $attrs.align"
          :header-align="'center' || $attrs.headerAlign || $attrs['header-align']"
      >
        <template v-for="item in slotArray" v-slot:[item]="scope">
          <slot :name="item" v-bind="scope"></slot>
        </template>
      </x-table>
      <slot name="content"></slot>
    </template>
    <template v-slot:footer>
      <x-page-footer class="page-footer-remark" v-if="pageFooterConfig" :page-footer-config="pageFooterConfig" @dblclick="handlePageFooterDblclick"></x-page-footer>
      <slot name="footer" :total="total"></slot>
      <x-page-footer class="x-page-footer-dynamic-statistics" v-if="realDynamicStatisticsConfig.enabled" :page-footer-config="dynamicStatisticsPageFooterConfig"></x-page-footer>
      <el-pagination
          v-if="realPageConfig.show"
          :small="realPageConfig.small"
          background
          @size-change="handleSizeChange"
          @current-change="handlePageCurrentChange"
          :current-page="currentPage"
          highlight-hover-row
          :page-size="pageSize"
          :page-sizes="realPageConfig.pageSizes"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="text-align: right"
      ></el-pagination>
    </template>
  </x-page-container>
</template>

<script>
import XPageFooter from '@/component/x-page-footer/x-page-footer.vue';
import {Toolbar} from 'vxe-table';
import {Pagination, Tabs, TabPane} from 'element-ui';
import tableSettingConfigMixin from '../../mixin/table-setting-config-mixin';
import tableOperateConfigMixin from '../../mixin/table-operate-config-mixin';
import tableOperateMixin from '../../mixin/table-operate-mixin';
import listPageBaseMixin from './list-page-base-mixin';
import downloadDialogMixin from '@/component/x-download-dialog/download-dialog-mixin';
import pageMixin from '../../mixin/page-mixin';
import resizeMixin from '../../mixin/resize-mixin';
import singleListPageMixin from './single-list-page-mixin';
import {enhanceColumns} from '../../util/componentUtil';
export default {
  name: 'XListPage',
  inheritAttrs: false,
  components: {
    [Pagination.name]: Pagination,
    [Toolbar.name]: Toolbar,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [XPageFooter.name]: XPageFooter
  },
  mixins: [downloadDialogMixin, pageMixin, tableSettingConfigMixin, tableOperateConfigMixin, tableOperateMixin, resizeMixin, listPageBaseMixin, singleListPageMixin],
  props: {
    clipConfig: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  created () {
    // 完善列的信息
    enhanceColumns({columns: this.columns, sortable: this.columnSortable});
  }
};
</script>
<style lang="scss">
.x-list-page {
  .list-title {
    color: #505566;
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 10px;
  }
}
</style>
